module.exports = __webpack_public_path__ + "img/icon-fishing-black.20699c05.svg";